import { useState } from "react";

export default function QuoteForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    details: "",
  });
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const services = [
    "Construction & Civil Works",
    "ICT & IoT",
    "Electrical Installations",
    "Fire Protection Systems",
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);

    try {
      const res = await fetch("/send-email.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, formType: "quote" }),
      });

      const data = await res.json();

      if (data.ok) {
        setStatus("ok");
        setForm({ name: "", email: "", phone: "", service: "", details: "" });
      } else {
        setStatus("error");
        console.error(data.error);
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4">
      <div className="max-w-lg w-full bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-6 text-center">Request a Quote</h2>

        {status === "ok" && (
          <p className="mb-4 text-center text-green-600">Quote request sent!</p>
        )}
        {status === "error" && (
          <p className="mb-4 text-center text-red-600">
            Failed to send quote. Please try again.
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Your Phone Number"
            required
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          <select
            name="service"
            value={form.service}
            onChange={handleChange}
            required
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            <option value="">Select a Service</option>
            {services.map((s, idx) => (
              <option key={idx} value={s}>
                {s}
              </option>
            ))}
          </select>
          <textarea
            name="details"
            value={form.details}
            onChange={handleChange}
            placeholder="Project Details"
            rows="4"
            required
            className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          ></textarea>
          <button
            type="submit"
            disabled={sending}
            className="w-full bg-orange-600 text-white p-3 rounded hover:bg-orange-700 transition"
          >
            {sending ? "SENDING..." : "Send Request"}
          </button>
        </form>
      </div>
    </div>
  );
}
